import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutRoutes from "./LayoutRoutes";
import { authRoutes } from "./AuthRoutes";
import Login from "../Componant/Authentication/Login";
import QaReports from "../Componant/Dashboard/Teacher/Profile/Calendar/qareports";
import LdQaReports from "../Componant/Dashboard/Teacher/Profile/Calendar/ldqareports";
import SeeQAScorePage from "../Componant/Dashboard/Teacher/Profile/SeeQAScorePage";
import { isSalesRestrictedUser, isTeacherLeaderDisabled, isTelephonyOnlyUser, SALES_HOME, TELEPHONY_ONLY_HOME } from "../utils/permissions";

const RouterData = () => {
  const login = localStorage.getItem("login");
  const defaultPath = isSalesRestrictedUser()
    ? SALES_HOME
    : isTelephonyOnlyUser()
    ? TELEPHONY_ONLY_HOME
    : isTeacherLeaderDisabled()
    ? `${process.env.PUBLIC_URL}/pages/teacher-profile`
    : `${process.env.PUBLIC_URL}/pages/student-profile`;
  return (
    <BrowserRouter
      basename={"/"}
      future={{
        v7_startTransition: true,
      }}
    >
      <Routes>
      {login ? (
          <>
            <Route
              path={`${process.env.PUBLIC_URL}` || '/'}
              element={
                <Navigate to={defaultPath} />
              }
            />
          </>
        ) : (
          ""
        )}
        <Route path={"/"} element={<PrivateRoute />}> 
          <Route path={`${process.env.PUBLIC_URL}/pages/qa-analysis`} element={<QaReports />} />
          <Route path={`${process.env.PUBLIC_URL}/pages/ld-qa-analysis`} element={<LdQaReports />} />
          <Route path={`${process.env.PUBLIC_URL}/pages/see-qa-score/:teacherUserId`} element={<SeeQAScorePage />} />
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
        {authRoutes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}
        <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterData;
